import { ROUTE } from 'shared/constants/routes_old';
import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RegisterConfirmedContainer = styled('div', { name: 'RegisterConfirmedContainer' })(
	({ theme }) => ({
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(6),
		textAlign: 'center',
	})
);

export default function RegisterConfirmed() {
	return (
		<RegisterConfirmedContainer>
			<Typography variant="h2">
				You’re all set
				<br />
				Let the revolution begin!
			</Typography>
			<Typography>
				<Link href={ROUTE.login}>Log into to begin</Link>
			</Typography>
		</RegisterConfirmedContainer>
	);
}
